import React, { useState, useEffect } from "react";
import { MdFileUpload } from "react-icons/md";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';

import InputPassword from "../InputPassword.component";
import ServicesSelect from "../CustomSelect/ServicesSelect.component";

/**
 *
 * Roles ************
 *
 * Service Provider = 2      (Freelancer who done work)
 * Customer = 3              (Who Post Jobs)
 *
 * Register from App = app
 */

// Freelancer / Contractor / Service Provider
export default function ContractorRegister() {

  const [latlong, setLatLong] = useState({});
  const [googleInfo, setGoogleInfo] = useState({});

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(function(position) {
      console.log("Latitude is :", position.coords.latitude);
      console.log("Longitude is :", position.coords.longitude);
      setLatLong({
        lat: position.coords.latitude,
        lng: position.coords.longitude
      });
    });
  }, []);

  const formik = useFormik({
    initialValues: {
      serviceType: '',
      companyName: "",
      experience: "",
      email: "",
      phone: "",
      licenseDoc: "",
      insuranceDoc: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      companyName: Yup.string().required("Required"),
      experience: Yup.string().required("Required"),
      email: Yup.string().email().required("Required"),
      phone: Yup.number()
        .min("7", "Must have atleast 7 characters.")
        .required("Required"),
      password: Yup.string()
        .min("3", "Password Must be atleast 3 characters")
        .required("Required"),
      confirmPassword: Yup.string().oneOf(
        [Yup.ref("password"), null],
        "Passwords must match"
      ),
      insuranceDoc: Yup.mixed().required("Required"),
      licenseDoc: Yup.mixed().required("Required"),
    }),
    onSubmit: async (values) => {

      if (Object.keys(latlong).length > 0) {

      let formData = new FormData();
      formData.append("service_id", values.serviceType);
      formData.append("user_name", values.companyName);
      formData.append("experience", values.experience);
      formData.append("email", values.email);
      formData.append("password", values.password);
      formData.append("confirm_password", values.confirmPassword);
      formData.append("phone_number", values.phone);
      formData.append("address", "main road");
      formData.append("role", 2);  // User Type Service Provider (who do job)
      formData.append("user_type", "app");
      formData.append("latitude", 32.323423);
      formData.append("longitude", 73.583653);
      formData.append("license_document", values.licenseDoc);
      formData.append("insurance_document", values.insuranceDoc);

      // registering Contractor online
      await fetch(`${process.env.REACT_APP_BASE_URL}/api/register_user`, {
        method: "POST",
        body: formData,
      })
        .then((r) => r.json())
        .then((response) => {
          if(response.success){
            toast.success(response.message);
          } else {
            toast.error(response.message);
          }
        });
      } else {
        toast.error("Please Allow Location to proceed.");
      }
    },
  });

  // handle License Document to Upload
  const handleLicenseDOc = (e) => {
    let lcFile = e.target.files[0];
    formik.setFieldValue("licenseDoc", lcFile);
  };

  // handle Insurance Document to Upload
  const handleInsuranceDoc = (e) => {
    let insFile = e.target.files[0];
    formik.setFieldValue("insuranceDoc", insFile);
  };
  

  return (
    <>
      <form
        className="bds-themeform"
        onSubmit={formik.handleSubmit}
      >
        <fieldset>
          <div className="bds-themeform__wrap">
            <div className="form-group flex-column align-items-start">
              <p className="text-sky-blue mb-1">Select Service Type</p>
              <ServicesSelect
                className="bds-register-form-select w-100"
                // onChange={formik.handleChange}
                // onBlur={formik.handleBlur}
                onChange={value=>formik.setFieldValue('serviceType',value.value)}
                name="serviceType"                
                value={formik.values.serviceType}
              />
              
            </div>

            <div className="form-group flex-column align-items-start">
              <div
                className={`bds-placeholderholder ${
                  formik.touched.companyName && formik.errors.companyName
                    ? "border border-danger"
                    : ""
                }`}
              >
                <input
                  name="companyName"
                  type="text"
                  className={`form-control bds-themeinput`}
                  placeholder="Company Name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              <p className="m-0">
                {formik.touched.companyName && formik.errors.companyName ? (
                  <small className="text-danger">
                    {formik.errors.companyName}
                  </small>
                ) : null}
              </p>
            </div>

            <div className="form-group flex-column align-items-start">
              <div
                className={`bds-placeholderholder ${
                  formik.touched.experience && formik.errors.experience
                    ? "border border-danger"
                    : ""
                }`}
              >
                <input
                  name="experience"
                  type="text"
                  className={`form-control bds-themeinput`}
                  placeholder="Experience"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              <p className="m-0">
                {formik.touched.experience && formik.errors.experience ? (
                  <small className="text-danger">
                    {formik.errors.experience}
                  </small>
                ) : null}
              </p>
            </div>

            <div className="form-group flex-column align-items-start">
              <div
                className={`bds-placeholderholder ${
                  formik.touched.phone && formik.errors.phone
                    ? "border border-danger"
                    : ""
                }`}
              >
                <input
                  name="phone"
                  type="text"
                  className={`form-control bds-themeinput`}
                  placeholder="Phone Number"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              <p className="m-0">
                {formik.touched.phone && formik.errors.phone ? (
                  <small className="text-danger">
                    {formik.errors.phone}
                  </small>
                ) : null}
              </p>
            </div>

            <div className="form-group flex-column align-items-start">
              <div
                className={`bds-placeholderholder ${
                  formik.touched.email && formik.errors.email
                    ? "border border-danger"
                    : ""
                }`}
              >
                <input
                  name="email"
                  type="email"
                  className={`form-control bds-themeinput`}
                  placeholder="Email Address"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              <p className="m-0">
                {formik.touched.email && formik.errors.email ? (
                  <small className="text-danger">{formik.errors.email}</small>
                ) : null}
              </p>
            </div>

            <div className="form-group flex-column align-items-start">
              <InputPassword
                name="password"
                noIcon={true}
                placeholder="Password"
                className="form-control bds-themeinput"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                errorclassName={
                  formik.touched.password && formik.errors.password
                    ? "border border-danger"
                    : ""
                }
              />
              <p className="m-0">
                {formik.touched.password && formik.errors.password ? (
                  <small className="text-danger">
                    {formik.errors.password}
                  </small>
                ) : null}
              </p>
            </div>
            <div className="form-group flex-column align-items-start">
              <InputPassword
                name="confirmPassword"
                noIcon={true}
                placeholder="Confirm Password"
                className="form-control bds-themeinput"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                errorclassName={
                  formik.touched.confirmPassword &&
                  formik.errors.confirmPassword
                    ? "border border-danger"
                    : ""
                }
              />
              <p className="m-0">
                {formik.touched.confirmPassword &&
                formik.errors.confirmPassword ? (
                  <small className="text-danger">
                    {formik.errors.confirmPassword}
                  </small>
                ) : null}
              </p>
            </div>

            <div className="form-group flex-column align-items-start">
              <h5>Upload License</h5>
              <div className="w-100 d-flex align-items-start position-relative">
                <div className="docs-dot-purple"></div>
                <div
                  className="documentContainer purple-bg d-flex align-items-center justify-content-between d-block"
                  onClick={() => {
                    document.getElementById("licenseDoc").click();
                  }}
                >
                  <div className="">
                    <h5>License Document</h5>
                    <p>05 March, 2022 At 03:30 . 3.4 MB</p>
                  </div>
                  <MdFileUpload />
                  <input
                    type="file"
                    id="licenseDoc"
                    name="licenseDoc"
                    className="d-none"
                    accept=""
                    onChange={(e) => handleLicenseDOc(e)}
                  />
                </div>
              </div>
              <p className="m-0 text-end w-100">
                {formik.touched.licenseDoc && formik.errors.licenseDoc ? (
                  <small className="text-danger">
                    {formik.errors.licenseDoc}
                  </small>
                ) : null}
              </p>
            </div>
            <div className="form-group flex-column align-items-start">
              <h5>Insurance Document</h5>
              <div className="w-100 d-flex align-items-start position-relative">
                <div className="docs-dot-green"></div>
                <div
                  className="insuranceContainer green-bg d-flex align-items-center justify-content-between d-block"
                  onClick={() => {
                    document.getElementById("insuranceDoc").click();
                  }}
                >
                  <div className="">
                    <h5>Insurance Document</h5>
                    <p>05 March, 2022 At 03:30 . 3.4 MB</p>
                  </div>
                  <MdFileUpload />
                  <input
                    type="file"
                    id="insuranceDoc"
                    name="insuranceDoc"
                    className="d-none"
                    onChange={(e) => handleInsuranceDoc(e)}
                  />
                </div>
              </div>
              <p className="m-0 text-end w-100">
                {formik.touched.insuranceDoc && formik.errors.insuranceDoc ? (
                  <small className="text-danger">
                    {formik.errors.insuranceDoc}
                  </small>
                ) : null}
              </p>
            </div>

            <div className="bds-popup-terms form-group">
              <button type="submit" name="submit" className="bds-btn-solid-lg">
                Sign Up
              </button>
            </div>
          </div>
        </fieldset>
      </form>
      <ToastContainer />
    </>
  );
}
